import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import NavTagline from "../nav-tagline/nav-tagline";
import CallAPI from "../../services/apiCalls";
import Footer from "../shared/Footer";
import useUserStore from "../../utils/storeApp";

const ExperianResults = () => {
    const [processing, SetProcessing] = useState(false);
    const [searchParams] = useSearchParams();
    const { userToken } =
        useUserStore((state) => ({
            userToken: state.userToken
        }));

    useEffect(() => {

        const initialize = async () => {
            SetProcessing(true);

            const foundResult = searchParams.get("result");

            let call = "/experian/ExperianResult?result=" + foundResult;
            const res = await CallAPI(call, false, "POST", userToken);

            SetProcessing(false);
        };

        initialize();
    }, []);

    return (
        <>
            {processing ? (
                <div className="loading"></div>
            ) : (
                <div className="ExperianResults">
                    <NavTagline />
                    <section class="layout-container">
                        <div className="container ctr">
                            <div className="text-size3 or-clr"><i class="bi bi-clock-history"></i></div>
                            <div className="text-size5 or-clr"><p>Almost Ready! </p></div>
                            <div className="text-size4">An Enrollment Specialist will be in contact with you shortly to complete setting up your account. </div>
                            <div className="text-size9 sp-margin10">If you need immediate support, please email SES Enrollment at <a href="mailto:enrollment@secureexsolutions.com">enrollment@secureexsolutions.com</a> or call 1.888.470.9913 ext 1.</div>
                        </div>
                    </section>
                    <Footer />
                </div>
            )}
        </>
    );
};

export default ExperianResults;